import { render, staticRenderFns } from "./CompanyQuestionnaireAnswer.vue?vue&type=template&id=6282b888&"
import script from "./CompanyQuestionnaireAnswer.vue?vue&type=script&lang=js&"
export * from "./CompanyQuestionnaireAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports